var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.$slots.items
      ? _c("div", { staticClass: "col-12 col-lg-12" }, [
          _c(
            "div",
            {
              ref: "carouselContainer",
              staticClass:
                "list-item-carousel owl-carousel owl-theme owl-single-item"
            },
            _vm._l(_vm.$slots.items, function(item, index) {
              return _c("slot-component", {
                key: index,
                attrs: { vnode: item }
              })
            }),
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }